export default {"src":"/_next/static/media/logo-inline-black.27f6dc80.svg","height":3149,"width":3149,"blurWidth":0,"blurHeight":0};